import { render, staticRenderFns } from "./RecruitmentContactEdit.vue?vue&type=template&id=07e1c60a&scoped=true&lang=pug"
import script from "./RecruitmentContactEdit.vue?vue&type=script&lang=ts"
export * from "./RecruitmentContactEdit.vue?vue&type=script&lang=ts"
import style0 from "./RecruitmentContactEdit.vue?vue&type=style&index=0&id=07e1c60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e1c60a",
  null
  
)

export default component.exports